import {IconBadge} from '@cohort/merchants/components/IconBadge';
import type {OwnershipObtentionType} from '@cohort/shared/schema/common/ownerships';
import {DownloadSimple, Flag, PaperPlane, ShoppingCart} from '@phosphor-icons/react';
import {useTranslation} from 'react-i18next';
import {match} from 'ts-pattern';

const DigitalAssetObtentionBadge = ({status}: {status: OwnershipObtentionType}): JSX.Element => {
  const {t} = useTranslation('pages', {
    keyPrefix: 'users.user.digitalAssets.digitalAssetObtentionBadge',
  });
  return match(status)
    .with('ordered', () => (
      <IconBadge
        text={t('ordered')}
        icon={<ShoppingCart className="mr-1 inline-block h-4 w-4 text-primary" />}
      />
    ))
    .with('imported', () => (
      <IconBadge
        text={t('imported')}
        icon={<DownloadSimple className="mr-1 inline-block h-4 w-4 text-orange-500" />}
      />
    ))
    .with('airdrop', () => (
      <IconBadge
        text={t('airdrop')}
        icon={<PaperPlane className="mr-1 inline-block h-4 w-4 text-green-500" />}
      />
    ))
    .with('journey', () => (
      <IconBadge
        text={t('journey')}
        icon={<Flag className="mr-1 inline-block h-4 w-4 text-teal-500" />}
      />
    ))
    .exhaustive();
};
export default DigitalAssetObtentionBadge;
